import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { applyPolyfills, defineCustomElements } from "web-ui-components/loader";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { KeyboardUtil } from "./app/shared/utils/keyboard.util";

if (environment.production) {
  enableProdMode();
}

document.addEventListener(
  "DOMContentLoaded",
  () => {
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
    KeyboardUtil.initialize();
  },
  { passive: true }
);

applyPolyfills().then(() => {
  defineCustomElements(window);
});
